import { useQuery } from '@tanstack/react-query';
import { hasAcceptedCurrentCgu } from '@/services/cguAcceptance';
import { CGU_VERSION } from '@/lib/cgu';

// Statut d'acceptation de la version courante des CGU pour l'utilisateur.
// Regle metier : RGPD-R01 (PRODUIT/domaine/19_donnees_personnelles.md) — alimente le gate.
// Alimente le gate dans AuthLayout. staleTime infini : l'acceptation ne bouge pas en
// cours de session ; on invalide la cle ['cgu-acceptation'] apres une acceptation.
export function useHasAcceptedCgu(userId: string | undefined) {
  return useQuery({
    queryKey: ['cgu-acceptation', userId, CGU_VERSION],
    queryFn: () => hasAcceptedCurrentCgu(userId as string),
    enabled: !!userId,
    staleTime: Infinity,
    meta: { toastErreur: false },
  });
}
